var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPredictive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.0001C24.0012 16.6001 23.9224 16.2039 23.7682 15.8348C23.614 15.4658 23.3876 15.1313 23.1023 14.851C22.8169 14.5707 22.4784 14.3503 22.1067 14.2028C21.7349 14.0552 21.3374 13.9835 20.9375 13.9919C20.5376 14.0002 20.1434 14.0884 19.7781 14.2513C19.4128 14.4142 19.0838 14.6485 18.8104 14.9405C18.537 15.2324 18.3247 15.576 18.186 15.9512C18.0474 16.3264 17.9852 16.7255 18.003 17.1251C17.4152 17.2762 16.8695 17.5591 16.4072 17.9524C15.945 18.3456 15.5782 18.8389 15.3348 19.3949C15.0914 19.9509 14.9778 20.5549 15.0024 21.1614C15.027 21.7678 15.1893 22.3606 15.477 22.8951C14.9712 23.306 14.5734 23.8343 14.3183 24.434C14.0632 25.0337 13.9586 25.6866 14.0134 26.336C14.0682 26.9854 14.2808 27.6116 14.6328 28.1601C14.9848 28.7085 15.4655 29.1627 16.033 29.4831C15.9629 30.0253 16.0047 30.5761 16.1559 31.1016C16.307 31.627 16.5643 32.1159 16.9118 32.538C17.2593 32.9601 17.6896 33.3065 18.1762 33.5558C18.6628 33.8051 19.1954 33.952 19.741 33.9874C20.2866 34.0228 20.8336 33.946 21.3484 33.7617C21.8631 33.5774 22.3346 33.2895 22.7338 32.9158C23.1329 32.5421 23.4512 32.0906 23.669 31.5891C23.8867 31.0876 23.9994 30.5468 24 30V17.0001Z",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.0001C23.9988 16.6001 24.0776 16.2039 24.2318 15.8348C24.386 15.4658 24.6124 15.1313 24.8977 14.851C25.1831 14.5707 25.5216 14.3503 25.8933 14.2028C26.2651 14.0552 26.6626 13.9835 27.0625 13.9919C27.4624 14.0002 27.8566 14.0884 28.2219 14.2513C28.5872 14.4142 28.9162 14.6485 29.1896 14.9405C29.463 15.2324 29.6753 15.576 29.8139 15.9512C29.9526 16.3264 30.0148 16.7255 29.997 17.1251C30.5848 17.2762 31.1305 17.5591 31.5928 17.9524C32.055 18.3456 32.4218 18.8389 32.6652 19.3949C32.9086 19.9509 33.0222 20.5549 32.9976 21.1614C32.973 21.7678 32.8107 22.3606 32.523 22.8951C33.0288 23.306 33.4266 23.8343 33.6817 24.434C33.9367 25.0337 34.0414 25.6866 33.9866 26.336C33.9318 26.9854 33.7192 27.6116 33.3672 28.1601C33.0152 28.7085 32.5345 29.1627 31.967 29.4831C32.0371 30.0253 31.9953 30.5761 31.8441 31.1016C31.693 31.627 31.4357 32.1159 31.0882 32.538C30.7407 32.9601 30.3104 33.3065 29.8238 33.5558C29.3372 33.8051 28.8046 33.952 28.259 33.9874C27.7134 34.0228 27.1664 33.946 26.6516 33.7617C26.1369 33.5774 25.6654 33.2895 25.2662 32.9158C24.8671 32.5421 24.5488 32.0906 24.331 31.5891C24.1132 31.0876 24.0006 30.5468 24 30V17.0001Z",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25C26.1604 24.7047 25.4273 24.167 24.8933 23.455C24.3593 22.743 24.0485 21.8887 24 21C23.9515 21.8887 23.6407 22.743 23.1067 23.455C22.5727 24.167 21.8396 24.7047 21 25",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.599 18.5C29.841 18.0806 29.9779 17.6088 29.998 17.125",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.003 17.125C18.0228 17.6087 18.1593 18.0805 18.401 18.5",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.477 22.896C15.6599 22.747 15.8557 22.6145 16.062 22.5",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.938 22.5C32.1443 22.6145 32.3401 22.747 32.523 22.896",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30C17.3108 30.0003 16.6333 29.8226 16.033 29.484",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.967 29.484C31.3667 29.8226 30.6892 30.0003 30 30",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictive);
export default __webpack_public_path__ + "static/media/Predictive.cc35423be683d030e3a58b3b702bf7ea.svg";
export { ForwardRef as ReactComponent };